import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const myCustomTheme = {
  dark: false,
  colors: {
    primary: '#40c1ac',    // your color 1
    secondary: '#888B8D',  // your color 2
    tertiary: '#75787B',   // your color 3 (custom name)
    background: '#f5f5f5', // optional, set background color here too
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'myCustomTheme',  // use your custom theme as default
    themes: {
      myCustomTheme,
      // optional fallback light theme
    },
  },
})
